/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BoxLineItem } from './BoxLineItem';
import {
    BoxLineItemFromJSON,
    BoxLineItemFromJSONTyped,
    BoxLineItemToJSON,
    BoxLineItemToJSONTyped,
} from './BoxLineItem';

/**
 * 
 * @export
 * @interface BoxPackItem
 */
export interface BoxPackItem {
    /**
     * 已有箱子 id；新建不传。也可仅用 markNo 在订单内匹配已有运输箱
     * @type {number}
     * @memberof BoxPackItem
     */
    boxId?: number;
    /**
     * 唛头号（运输箱必填语义由业务校验）
     * @type {string}
     * @memberof BoxPackItem
     */
    markNo: string;
    /**
     * 纸箱类型：1 库存 2 运输
     * @type {number}
     * @memberof BoxPackItem
     */
    boxType: number;
    /**
     * 计费物料 ID；大于 0 表示参与计费的系统物料，0 表示不参与计费的自定义箱；部分装箱暂存时可为空，完成包装前必须补齐
     * @type {number}
     * @memberof BoxPackItem
     */
    materialId?: number;
    /**
     * 是否单独保管：0 否 1 是
     * @type {number}
     * @memberof BoxPackItem
     */
    separateStore?: number;
    /**
     * 是否包含入库检查有误商品：0 否，1 是
     * @type {number}
     * @memberof BoxPackItem
     */
    containsErrorGoods?: number;
    /**
     * 重量 kg
     * @type {number}
     * @memberof BoxPackItem
     */
    wtKg?: number;
    /**
     * CBM 立方米；部分装箱暂存时可为空，完成包装前必须补齐
     * @type {number}
     * @memberof BoxPackItem
     */
    cbm?: number;
    /**
     * 长 cm
     * @type {number}
     * @memberof BoxPackItem
     */
    length?: number;
    /**
     * 宽 cm
     * @type {number}
     * @memberof BoxPackItem
     */
    width?: number;
    /**
     * 高 cm
     * @type {number}
     * @memberof BoxPackItem
     */
    height?: number;
    /**
     * 箱内商品行
     * @type {Array<BoxLineItem>}
     * @memberof BoxPackItem
     */
    details: Array<BoxLineItem>;
}

/**
 * Check if a given object implements the BoxPackItem interface.
 */
export function instanceOfBoxPackItem(value: object): value is BoxPackItem {
    if (!('markNo' in value) || value['markNo'] === undefined) return false;
    if (!('boxType' in value) || value['boxType'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function BoxPackItemFromJSON(json: any): BoxPackItem {
    return BoxPackItemFromJSONTyped(json, false);
}

export function BoxPackItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxPackItem {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'markNo': json['markNo'],
        'boxType': json['boxType'],
        'materialId': json['materialId'] == null ? undefined : json['materialId'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'containsErrorGoods': json['containsErrorGoods'] == null ? undefined : json['containsErrorGoods'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'details': ((json['details'] as Array<any>).map(BoxLineItemFromJSON)),
    };
}

export function BoxPackItemToJSON(json: any): BoxPackItem {
    return BoxPackItemToJSONTyped(json, false);
}

export function BoxPackItemToJSONTyped(value?: BoxPackItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'markNo': value['markNo'],
        'boxType': value['boxType'],
        'materialId': value['materialId'],
        'separateStore': value['separateStore'],
        'containsErrorGoods': value['containsErrorGoods'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'details': ((value['details'] as Array<any>).map(BoxLineItemToJSON)),
    };
}

